import React from 'react';

interface Props {
    onClick?: React.MouseEventHandler<HTMLInputElement>
    checked?: boolean,
}

const HanCheckbox: React.FC<Props> = ({ onClick, checked }) => {
    return (
        <div className="han-checkbox">
            <input
                type="checkbox"
                onClick={onClick}
                checked={checked}
                onChange={() => {}}
            />
            <div className="han-checkbox__icon">
            </div>
        </div>
    )
}

export default HanCheckbox;